import { render, staticRenderFns } from "./ProductToCartButton.vue?vue&type=template&id=45a5ab60&"
import script from "./ProductToCartButton.vue?vue&type=script&lang=ts&"
export * from "./ProductToCartButton.vue?vue&type=script&lang=ts&"
import style0 from "./ProductToCartButton.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@nuxt/webpack/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports